module.exports = __webpack_public_path__ + "static/media/signup.be1db512.png";